<template>
  <button
    class="menu"
    :class="{ opened: menuOpened }"
    aria-label="Main Menu"
    @click="$emit('openMenu')"
  >
    <div class="flex items-center">
      <div class="sm:ltr:mr-3 sm:rtl:ml-3 ltr">
        <div class="flex items-center justify-between w-5 mb-[6px] menu-icon">
          <div
            class="w-[6px] h-[6px] rounded-full menu-dots"
            :style="`background:${color}`" :class="{ 'dots-animate': menuOpened }"
          ></div>
          <div
            class="w-[6px] h-[6px] rounded-full menu-dots"
            :style="`background:${color}`" :class="{ 'dots-animate': menuOpened }"
          ></div>
        </div>
        <div class="flex items-center justify-between w-5  menu-icon-2">
          <div
            class="w-[6px] h-[6px] rounded-full menu-dots"
            :style="`background:${color}`" :class="{ 'dots-animate': menuOpened }"
          ></div>
          <div
            class="w-[6px] h-[6px] rounded-full menu-dots"
            :style="`background:${color}`" :class="{ 'dots-animate': menuOpened }"
          ></div>
        </div>
      </div>
      <div class="relative  overflow-hidden w-[52px] transition-all duration-300 h-[24px] sm:flex hidden">
        <div :style="`color:${color}`" class="text-base menu-btn-text-closed" :class="{'opened':menuOpened}">{{content.menu}}</div>
      <div :style="`color:${color}`" class="text-base menu-btn-text-open" :class="{'opened':menuOpened}">{{content.close}}</div>
      </div>
    </div>
    <!-- <svg width="50" height="50" viewBox="0 0 100 100">
      <path
        class="line line1"
        :style="`stroke:${color}`"
        d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
      />
      <path class="line line2" d="M 20,45 H 80" :style="`stroke:${color}`" />
      <path
        class="line line3"
        :style="`stroke:${color}`"
        d="M 20,60.999954 H 80.000231 C 80.000231,60.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
      />
    </svg> -->
  </button>
</template>
<script>
export default {
  props: ["menuOpened", "color"],
  inject: ["content"],
};
</script>
<style scoped>
.menu {
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
}
.line {
  fill: none;
  stroke-width: 3;
  transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
}
.line1 {
  stroke-dasharray: 60 207;
  stroke-width: 3;
}
.line2 {
  stroke-dasharray: 60 60;
  stroke-width: 3;
}
.line3 {
  stroke-dasharray: 60 207;
  stroke-width: 3;
}
.opened .line1 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 3;
}
.opened .line2 {
  stroke-dasharray: 1 60;
  stroke-dashoffset: -30;
  stroke-width: 3;
}
.opened .line3 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 3;
}
</style>